<template>
    <CTable
        v-if="data.page"
        :isLoading="isLoading"
        v-model:columns="data.columns"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manages="data.manages"
        :manageExtras="data.manageExtras"
        :rowActions="data.rowActions"
        :clientSide="true"
        :canRefresh="false"
    ></CTable>
    <div class="has-error" v-if="data.useForm.validateInfos[itemsKey]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm.validateInfos[itemsKey]?.help }}
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { initData, isLoading } from "./sampling-monitor-product.logic";

export default defineComponent({
    components: {
        CTable: defineAsyncComponent(() => import("../../../../components/table/CTable")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        dataProp: {},
        itemsKey: {},
        fetchCriteria: {},
        visibleSamplingNo: { default: true },
        visibleSamplingRequest: { default: true },
        visibleSamplingNameTh: { default: true },
        visibleSamplingNameEn: { default: true },
        visibleSamplingMonitorSpecies: { default: true },
        visibleSamplingMonitorType: { default: true },
        visibleSamplingStoreDepartment: { default: true },
        visibleSamplingPool: { default: true },
        visibleSamplingSourceType: { default: true },
        visibleProvince: { default: true },
        visibleTransportNo: { default: true },
        visibleBlNo: { default: true },
        visibleBmdNo: { default: true },
        visibleImdNo: { default: true },
        visibleSourceProvince: { default: true },
        visibleStorePlace: { default: true },
        visibleLat: { default: true },
        visibleLng: { default: true },
        visibleFactoryName: { default: true },
        visibleMfgDate: { default: true },
        visibleSize: { default: true },
        visibleLotNo: { default: true },
        visibleTransportSourceCountry: { default: true },
        visibleTransportDestinationCountry: { default: true },
        visibleCountry1: { default: true },
        visibleIsMicro: { default: true },
        visibleIsChemi: { default: true },
        visibleIsPhysic: { default: true },
        visibleRequesterRemark: { default: true },
        visibleProductQualityStatus: { default: true },
        visibleOfficerAbnormalRemark: { default: true },
        disabledSamplingNameTh: { default: false },
        disabledSamplingNameEn: { default: false },
        disabledSamplingMonitorSpecies: { default: false },
        // disabledSamplingMonitorType: { default: false },
        disabledSamplingStoreDepartment: { default: false },
        disabledSamplingPool: { default: false },
        // disabledSamplingSourceType: { default: false },
        disabledProvince: { default: false },
        disabledTransportNo: { default: false },
        disabledBlNo: { default: false },
        disabledBmdNo: { default: false },
        disabledImdNo: { default: false },
        disabledSourceProvince: { default: false },
        disabledStorePlace: { default: false },
        disabledLat: { default: false },
        disabledLng: { default: false },
        disabledFactoryName: { default: false },
        disabledMfgDate: { default: false },
        disabledSize: { default: false },
        disabledLotNo: { default: false },
        disabledTransportSourceCountry: { default: false },
        disabledTransportDestinationCountry: { default: false },
        disabledCountry1: { default: false },
        disabledIsMicro: { default: false },
        disabledIsChemi: { default: false },
        disabledIsPhysic: { default: false },
        disabledRequesterRemark: { default: false },
        disabledProductQualityStatus: { default: false },
        disabledOfficerAbnormalRemark: { default: false },
        disabledSamplingMonitorProduct: { default: false },
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        return { props, data, refs, isLoading };
    },
});
</script>
